import { Component, computed, DestroyRef, effect, inject, input, OnInit, output, signal } from '@angular/core';
import { TFacetTypes } from "../facet-selection/facet-selection.component";
import { FacetAlias, UserFacet } from "../facet";
import { ValueAccessorDirective } from "../../../shared/form/value-accessor.directive";
import { FacetService } from "../facet.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { MultiFacetPillsComponent } from "../multi-facet-pills/multi-facet-pills.component";

@Component({
  selector: 'app-multi-facet-selection',
  standalone: true,
  imports: [MultiFacetPillsComponent],
  templateUrl: './multi-facet-selection.component.html',
  styleUrls: ['./multi-facet-selection.component.scss'],
  host: {
    class: 'block',
  },
  hostDirectives: [ValueAccessorDirective],
})
export class MultiFacetSelectionComponent implements OnInit {
  protected facetService = inject(FacetService);
  facets = input(this.facetService.userNoChapterFacetTypes())
  selectedFacetAliases = input<FacetAlias[]>([]);
  facetType = input<TFacetTypes>('user');
  selectedFacetChanged = output<UserFacet[]>();

  protected valueAccessor = inject(ValueAccessorDirective);
  protected destroyRef = inject(DestroyRef);

  private _selectedFacets = signal<FacetAlias[]>([]);

  readonly selectedFacets = computed(() => {
    const selected = this._selectedFacets();
    if (selected.length === 0 && this.selectedFacetAliases().length !== 0) {
      return this.selectedFacetAliases()
    }
    return selected;
  });

  constructor() {
    effect(() => {
      this._selectedFacets.set(this.selectedFacetAliases())
    });
  }

  ngOnInit(): void {
    this.getFacetTypes();
  }

  getFacetTypes() {
    const fetch$ =
      this.facetType() === 'all' ? this.facetService.getAllFacetTypes() : this.facetService.getUserFacetTypes();

    fetch$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
  }

  toggleSelectedFacet(facetData:{facet: UserFacet, selected: boolean}): void {
    let updated: FacetAlias[];

    const facet = facetData.facet;
    const current = this._selectedFacets();
    const index = current.indexOf(facet.alias);

    if (index >= 0) {
      if (facetData.selected) {
        updated = current;
      } else {
        current.splice(index, 1);
        updated = current
      }
    } else {
      updated = [...current, facet.alias]
    }

    this._selectedFacets.set(updated)

    const selectedFacetObjects = this.facets().filter((f) => updated.includes(f.alias));
    this.selectedFacetChanged.emit(selectedFacetObjects);

    const selectedIds = selectedFacetObjects.map((f) => f.id);
    this.valueAccessor.valueChange(selectedIds);
    this.valueAccessor.touchedChange(true);
  }

  onFilter(data: {facet: UserFacet, selected: boolean}): void {
    this.toggleSelectedFacet(data);
    this.getFacetTypes();
  }
}
